import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/grid';
import { useProduct } from '@thd-nucleus/data-sources';
import { SupportedDocuments } from './SupportedDocuments';
import { DownloadAdobe } from '../DownloadAdobe/DownloadAdobe';
import './quick-links.scss';

export const getDocumentList = (documents) => {

  let documentList = [
    {
      name: 'Full Product Details',
    },
    {
      name: 'Specifications',
    },
    ...(documents || []),
    {
      name: 'Returns',
      url: 'https://www.homedepot.com/c/Return_Policy'
    }
  ];

  if (documents && documents.length) {
    documentList.push({
      name: 'Info & Guides',
    });
  }
  return documentList;
};

const onClickQuickLink = (document) => {
  const { cardSectionName, scrollToBottom = false, name } = document || {};
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && (cardSectionName || name)) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-overview.card-click',
      { scrollToBottom, cardSectionName, target: name });
  }
};

export const QuickLinks = ({ itemId }) => {
  const { data, loading, error } = useProduct({
    itemId,
    domains: ['specificationGroup', 'info', 'media', 'identifiers', 'details']
  });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const { infoAndGuides } = data?.product?.details || {};
  const documentList = getDocumentList(infoAndGuides).map((doc) => {
    const supported = SupportedDocuments.find((item) => item.name === doc.name);
    if (!supported) {
      return null;
    }
    return {
      ...doc,
      ...supported
    };
  }).filter((doc) => !!doc);

  return (
    <>
      {documentList.map((doc, index) => {
        const {
          cardSectionName, displayName, image, openCard, url
        } = doc;
        const classes = classNames('quick-links-information', {
          'quick-links-information--last': index === documentList.length - 1
        });
        return (
          <div className="quick-links-wrapper" key={`quick-links-${index}`}>
            <Col className={classes}>
              <Col fallback="2">
                <img src={image} alt="Logo" />
              </Col>
              {!openCard
              && (
                <a href={url} rel="noopener noreferrer" target="_blank" onClick={() => { onClickQuickLink(doc); }}>
                  <Col fallback="9">{displayName}</Col>
                </a>
              )}
              {/* eslint-disable */}
              {openCard && cardSectionName
              && (
                <a onClick={() => { onClickQuickLink(doc); }}>
                  <Col fallback="9">
                    <span role="presentation">{displayName}</span>
                  </Col>
                </a>
              )}
              {/* eslint-enable */}
            </Col>
          </div>
        );
      })}
      <DownloadAdobe />
    </>
  );
};

QuickLinks.displayName = 'QuickLinks';

QuickLinks.propTypes = {
  itemId: string.isRequired
};
